<template>
  <div class="countries">
    <div class="container"> 
      <h1 class="headline">GCO {{$t('message.countries')}}</h1>
      <div class="loading" v-if="countries.length === 0"></div> 
      <div class="simple-list-outer" v-if="countries.length > 0">  
      
        <div class="simple-list-item" v-for="item in countries" :key="item.id" @click="goCountry(item.id, item.name)">  
          <div class="simple-list-item-image"><img class="list-flag" :src="flagPath + item.img"/></div>
          <div class="simple-list-item-title">{{item.name}}</div>
          <div class="simple-list-item-additional">{{item.memberCount}}</div>               
        </div> 
       
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Countries',
  data () {
    return {
      searchText: '',
      eventIndex: 0
    }
  },
  methods: {
    getCountries: function () {
      this.$store.dispatch('countries/getAll')
    },
    goCountry: function (id, name) {
      var breadcrumb = {
        name: name,
        route: '/country/' + id
      }
      this.$store.commit('ADD_BREADCRUMB', breadcrumb)
      this.$router.push(breadcrumb.route)
    }
  },
  created: function () {
    this.getCountries()
  },
  /*
  computed: {
    ...mapGetters('countries', [
      'list',
      'details'
    ])
  },
  */
  computed: {
    ...mapGetters({
      countries: 'countries/list',
      flagPath: 'countries/flagsPath'
    })
  },
  activated: function () {
    console.log(this.$store)
  }
}
</script>
